import React from 'react';
import { Col, Row, FullRow } from '../framework/Grid';
import AcquireWebComponent from '../framework/MaterialUI';
import isEmpty from 'lodash/isEmpty';
import Select from 'react-select'
import { splitNumber } from '../../utils/utility'

class InsightAudienceData extends AcquireWebComponent {
	render(){
		const {title, data, footer} = this.props;
		if (isEmpty(data)) {
			return (
				<div style={{ float: "left", width: "100%", position: "relative" }}>
					<div style={{ fontSize: '16px', lineHeight: '18px', fontWeight:'bold' }}>{title}</div>
					<div style={{ width: '100%', minHeight: '190px', textAlign: 'center', paddingTop: '50px', color: "#CDCDCD" }}>
						<div style={{ color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' }}>No Data</div>
					</div>		
				</div>
			)
		} else {
			const options=[
				{ value: 'month2Date', label: 'Month to Date' },
				{ value: 'year2Date', label: 'Year to Date'}
			]
			return (
				<div className="insights-container">
					<div style={{ fontSize: '24px', lineHeight: '28px', fontWeight:'bold' }}>{title}</div>
					<FullRow className="no-padding-left pt-10 pb-10 no-margin-bottom" style={{fontSize: '16px'}}>
						<div style={{position:'absolute', top:'10px'}}>View Data</div>
						<Select style={{width:'140px'}}
									name=""
									value={this.props.period}
									clearable={false}
									options={options}
									onChange={this.props.handlePeriodChanged}
								/>
					</FullRow>
					<Row className="no-padding-left pt-10 pb-10" style={{fontSize: '16px'}}>
						<Col xs="6" sm="6" md="6" lg="6" className="light-grey-right-border pr-20">
							<div style={{lineHeight:'18px'}} className="mb-5 pb-10 light-grey-bottom-border">
								<strong>Insights Records Delivered</strong>
							</div>
							<div style={{lineHeight:'18px'}} className="light-grey-bottom-border pb-10 mb-5 pt-5">
								<span style={{width:'60%', textAlign:'left'}}>Consumer: </span>
								<span style={{width:'40%'}} className="text-right pull-right">{data.deliveredConsumers ? splitNumber(data.deliveredConsumers)() : '0'}</span>
							</div>
							<div style={{lineHeight:'18px'}} className="light-grey-bottom-border pt-5 pb-10 ">
								<span style={{width:'60%', textAlign:'left'}}>Business:</span>
								<span style={{width:'40%'}} className="text-right pull-right">{data.deliveredBusinesses ? splitNumber(data.deliveredBusinesses)() : '0'}</span>
							</div>
						</Col>
						<Col xs="6" sm="6" md="6" lg="6" className="pl-20">
							<div style={{lineHeight:'18px'}} className="mb-5 pb-10 light-grey-bottom-border">
								<strong>Audience Records Created</strong>
							</div>
							<div style={{lineHeight:'18px'}} className="light-grey-bottom-border pb-10 mb-5 pt-5">
								<span style={{width:'60%', textAlign:'left'}}>Consumer: </span>
								<span style={{width:'40%'}} className="text-right pull-right">{splitNumber(data.createdConsumers)()}</span>
							</div>
							<div style={{lineHeight:'18px'}} className="light-grey-bottom-border pt-5 pb-10">
								<span style={{width:'60%', textAlign:'left'}}>Business:</span>
								<span style={{width:'40%'}} className="text-right pull-right">{splitNumber(data.createdBusinesses)()}</span>
							</div>
						</Col>
					</Row>
					{
						footer && (
							<FullRow className="pl-10">
								{footer}
							</FullRow>
						)
					}

				</div>			
			)
		}

	}
}

export default InsightAudienceData


// WEBPACK FOOTER //
// ./src/components/Dashboard/insight-audience-data.jsx